import { createFileRoute } from '@tanstack/react-router';
import { IFellowshipKindEnum } from 'src/graphql/types';
import Fellowships from 'src/pages/Organization/Fellowships';

export const Route = createFileRoute('/$organizationSlug/mechanics/diseases/$')(
  {
    component: () => (
      <Fellowships allowMembershipsEdit type={IFellowshipKindEnum.Disease} />
    ),
  },
);
